export default __webpack_public_path__ + "static/media/empty-result-icon.db93813e.svg";